import { columnValidators, cdpProductColumnValidators } from '../../utilities/validators'
import { columnFormatters } from '../../utilities/formatters';

export function getMetadata(rows) {
  return rows.map((row, idx) => getRowMetadata(row, idx, rows))
}

export function getRowMetadata(row, idx, rows) {
  const meta = {};

  Object.keys(columnValidators).forEach((colName) => {
    const value = row[colName];
    const validator = columnValidators[colName];
    if (validator) {
      const validity = validator.getValidity(value, row, rows);
      if (!validity.isValid()) {
        meta[colName] = new CellMedatata(idx, colName, validity.getErrorMessages());
        return
      }
    }
    meta[colName] = new CellMedatata(idx, colName)
  });

  return meta
}

export function getCdpMetadata(rows) {
  return rows.map((row, idx) => getCdpRowMetadata(row, idx, rows))
}

export function getCdpRowMetadata(row, idx, rows) {
  const meta = {};

  Object.keys(cdpProductColumnValidators).forEach((colName) => {
    const value = row[colName];
    const validator = cdpProductColumnValidators[colName];
    if (validator) {
      const validity = validator.getValidity(value, row, rows);
      if (!validity.isValid()) {
        meta[colName] = new CellMedatata(idx, colName, validity.getErrorMessages());
        return
      }
    }
    meta[colName] = new CellMedatata(idx, colName)
  });

  return meta
}

export class CellMedatata {
  constructor(rowNumber, colName, errorMsgs = []) {
    this.rowNumber = rowNumber
    this.colName = colName
    this.errorMsgs = errorMsgs
  }

  getRowNumber() {
    return this.rowNumber
  }

  getColName() {
    return this.colName
  }

  getErrorMessages() {
    return this.errorMsgs
  }

  hasErrors() {
    return !!(this.errorMsgs && this.errorMsgs.length)
  }
}

export function resetProductServerErrorMsgsAndDirtyState(prods) {
  return prods.map((prod) => {
    return {
      ...prod,
      dirtyColumns: void 0,
      serverErrors: void 0,
    }
  })
}

export function addDirtyColumnToRow(row, columnName) {
  if (!row.dirtyColumns) {
    row.dirtyColumns = []
  }
  if (!~row.dirtyColumns.indexOf(columnName)) {
    row.dirtyColumns.push(columnName)
  }
  return row
}

export function formatProductColumns(product) {
  return Object.keys(columnFormatters).reduce((acc, columnName) => {
    const formatter = columnFormatters[columnName]
    acc[columnName] = (typeof formatter === 'function' ?
      columnFormatters[columnName](acc[columnName]) :
      acc[columnName]
    )
    return acc
  }, { ...product })
}


// WEBPACK FOOTER //
// ./components/product-detail/util.js